import { TemplatePreview } from './TemplatePreview';

export default TemplatePreview;
